<!--index:制卡模板首页 2024/04/02 13:59:17 YuAng-->

<template>
  <div class="card-index cnt1200">
    <card-query ref="query" @change="queryChange"></card-query>
    <div v-if="list.length" class="list-div">
      <el-table :data="list" size="big" border stripe>
        <el-table-column prop="templateName" align="center" label="模板名称"></el-table-column>
        <el-table-column prop="gradeName" width="80" align="center" label="年级"></el-table-column>
        <el-table-column prop="subjectName" width="100" align="center" label="学科"></el-table-column>
        <el-table-column align="center" label="类型" width="100px">
          <template slot-scope="scope">
            {{typeName(scope.row.templateType)}}
          </template>
        </el-table-column>
        <el-table-column align="center" label="题目详情" width="120px">
          <template slot-scope="scope">
            <span v-if="scope.row.questionCount > 0">
              {{scope.row.questionCount}}题/{{scope.row.totalScore}}分
            </span>
            <span v-else style="color: #FF4C3B">未切题</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="模板状态" width="100px">
          <template slot-scope="scope">
            <span v-if="scope.row.examId" :title="'考试名称：' + scope.row.examName" style="color: #2877FF">
              已使用
            </span>
            <span v-else>{{ setTemplateStatus(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="creatorName" align="center" width="120px" label="创建人"></el-table-column>
        <el-table-column align="center" label="是否公开" width="80">
          <template slot-scope="scope">
            <el-switch v-if="isAdmin(scope.row)" @change="changeOpen(scope.row)" v-model="scope.row.isOpen"></el-switch>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" width="150" align="center" label="创建时间">
          <template slot-scope="scope">
            {{formatDate(scope.row.createTime)}}
          </template>
        </el-table-column>
        <el-table-column width="200" align="center" label="操作">
          <template slot-scope="scope">
            <card-tool :item="scope.row" @change="loadData"></card-tool>
          </template>
        </el-table-column>
      </el-table>
      <yue-pagination style="margin: 20px 0;" :key="page.pagination" :page="page" @current-change="pageChange"></yue-pagination>
    </div>
    <data-empty v-else class="list-div page-empty" style="padding: 0" :loading="page.loading" empty-tip="暂无答题卡模板"></data-empty>
  </div>
</template>
<script>
import CardQuery from './components/CardQuery.vue'
import CardTool from './components/CardTool.vue'
import { cardData } from '@/v2/utils/data'
import { cardApi } from '@/v3/modules/card/utils/api'
import util from '@/v2/utils/util'
import DataEmpty from '@/v3/components/DataEmpty.vue';
import { mapGetters } from "vuex";
export default {
  components: { CardQuery, CardTool, DataEmpty },
  name: 'index',
  data () {
    return {
      page: {
        pagination: Date.now(),
        total: 0,
        size: 15,
        current: 1,
        loading: false
      },
      list: [],
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
      gradeList: 'getGradeList'
    })
  },
  created () {
    this.types = cardData.getCardTypes()
    this.loadData()
  },
  mounted () {
    // 组卷中心制卡跳转过来，逻辑适配
    if (this.$route.query.paperId && this.$route.name === 'CardIndex') {
      this.createZujuanCard()
    }
  },
  methods: {
    isAdmin: function (item) {
      let roles = this.userInfo.roles
      let isJz = false
      if (roles) {
        // 是否是教育局长
        isJz = roles.find(item => item.roleCode === '718071702')
      }
      return this.userInfo.isAdmin || isJz || item.creatorId === this.userInfo.userId
    },
    createZujuanCard () {
      const { gradeId, courseId, scene, paperId } = this.$route.query
      if (gradeId) {
        this.$router.push({ path: '/card/zujuan', query: { istemplate: 1, back2Zj: true, grade: gradeId, subjectCode: courseId, scene, paperId } })
      } else {
        this.$message.warning('缺少年级信息~')
      }
    },
    loadData: function () {
      this.page.loading = true
      if (this.page.current === 1) {
        this.page.pagination = Date.now()
        this.list = []
      }
      const params = {
        currentPage: this.page.current,
        pageSize: this.page.size,
        schoolId: this.userInfo.schoolId,
      }
      if (this.form) {
        params.creatorId = this.form.isMine ? this.userInfo.userId : ''
        params.grade = this.form.grade
        params.subjectCode = this.form.subject
        params.templateType = this.form.type
      }
      cardApi.templateList(params).then(resp => {
        if (resp.body) {
          const list = resp.body.items
          for (let index = 0; index < list.length; index++) {
            const element = list[index];
            element.isOpen = element.openStatus === 'OPEN'
            const grade = this.gradeList.find(item => item.gradeNum + '' === element.grade + '')
            element.gradeName = grade ? grade.gradeName : element.grade
          }
          this.list = list
          this.page.total = resp.body.totalSize
          this.page.loading = false
        }
      })
    },
    changeOpen (item) {
      const openStatus = item.isOpen ? 'OPEN' : 'SELF'
      const params = {
        id: item.id,
        status: openStatus,
        version: item.version
      }
      cardApi.templateStatus(params).then(resp => {
        if (!resp.success) {
          item.isOpen = !item.isOpen
        }
      })
    },
    pageChange (page) {
      this.page.current = page
      this.loadData()
    },
    queryChange (form) {
      this.form = form
      this.pageChange(1)
    },
    formatDate: util.formatDate,
    typeName (type) {
      const target = this.types.find(item => item.value === type)
      if (target) {
        return target.name
      } else {
        return '--'
      }
    },
    setTemplateStatus (item) {
      // 设置模板状态
      // 针对第三方制卡显示更加详细的状态
      let str = '未使用'
      if (item.templateType === 'THIRD_SHEET') {
        const completedSteps = {
          0: '无正反面',
          1: '无定位区',
          2: '无学生考号',
          3: '无试题',
          4: '已完成'
        }
        str = completedSteps[item.completedStep]
      }
      return str
    }
  },
  watch: {
    '$route': function (to, from) {
      this.loadData()
    }
  }
}
</script>

<style scoped>
.list-div {
  background-color: white;
  margin: 16px 0;
  min-height: calc(100vh - 258px);
  padding: 16px;
  border-radius: 6px;
}
</style>